import { Injectable } from '@angular/core';
import { isNotUndefined, Product, ProductScope, ProductService, RoutingService } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { distinctUntilChanged, filter, map, switchMap } from 'rxjs/operators';

// Наш продукт не шарит за города.
// Единственное и достаточне условие новизны продукта был новый код.
// Если код не меняется -- это старый продукт.
// Плюс еще вся городозависимость живет и в компонентах.
// Само собой при смене стора новый  продукт в коробке эмитится.
@Injectable({
  providedIn: 'root',
})
export class CustomCurrentProductService {
  protected readonly DEFAULT_PRODUCT_SCOPE = ProductScope.DETAILS;

  constructor(
    private routingService: RoutingService,
    private productService: ProductService,
  ) {}

  // тут попытка завязаться не на ебаный код, который во всех городах один, а на более специфичный показатель.
  // На цену + сток.
  // типа у нас товар от товара отдичается кодом,
  // а один и тот же товар в городах различается стоком и ценой.
  // вот их и сравниваем, и если чет поменялось, эмитим новый эмит с продукстом)

  getProduct(scopes?: (ProductScope | string)[] | ProductScope | string): Observable<Product | null> {
    return this.getCode().pipe(
      switchMap((productCode: string) => {
        return productCode ? this.productService.get(productCode, scopes || this.DEFAULT_PRODUCT_SCOPE) : of(null);
      }),
      filter<Product | null>(isNotUndefined),
      distinctUntilChanged((prev, next) => {
        if (prev === null || next === null) {
          return prev === next;
        }

        return (
          prev.stock?.stockLevel === next.stock?.stockLevel &&
          prev.price?.value === next.price?.value &&
          prev.code === next.code
        );
      }),
    );
  }

  protected getCode(): Observable<string> {
    return this.routingService.getRouterState().pipe(map((state) => state.state.params['productCode']));
  }
}
